import React from 'react'
import YouTubeSummarizer from './components/YouTubeSummarizer'

function App() {
  return <YouTubeSummarizer />
}

export default App
